define( [ 'jquery', 'utility' ], function( $, util ) {
	'use strict';

	var objectfit = {

		init : function( el ) {
			var $wrapper = $( el );

			if ( !$wrapper.hasClass( 'js-objectfit' ) ) {
				$wrapper.addClass( 'js-objectfit' );

				if ( !Modernizr.objectfit ) {
					var img_url = $wrapper.find( 'img' ).prop( 'src' );
					if ( img_url ) {
						$wrapper.css( 'backgroundImage', 'url(' + img_url + ')' )
							.removeClass( 'm-card--full-bleed m-hero--objectfit' )
							.addClass( 'compat-object-fit' );
					}
				}

				if ( $wrapper.hasClass( 'm-card' ) ) {
					var onResize = util.debounce( function() {
						$wrapper.css( 'min-height', 0 );
						$wrapper.find( '.m-card-image' ).css( 'height', 0 );
						$wrapper.cardImage_height = $wrapper.find( '.m-card-image img' ).outerHeight( true );
						$wrapper.cardContent_height = $wrapper.find( '.m-card-content' ).height();
						if ( $wrapper.cardImage_height > $wrapper.cardContent_height ) {
							$wrapper.css( 'min-height', $wrapper.cardImage_height );
						}
						$wrapper.find( '.m-card-image' ).css( 'height', '100%' );
					}, 10 );
					$( window ).on( 'resize', onResize );
					onResize();
				}
			}
		}
	};

	return {
		initInstance : function( el ) {
			objectfit.init( el );
		}
	};
});
